var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{on:{"click":_vm.changeState}},[_c('span',{staticClass:"plus icon-plus",class:_vm.intl}),_c('span',{staticClass:"btn-see-more"},[_vm._v(_vm._s(_vm.$t("app.readMore")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }